<template>
  <svg width="12" height="13" viewBox="0 0 12 13" fill="#0086C8" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6667 1.3H7.88C7.6 0.546 6.86667 0 6 0C5.13333 0 4.4 0.546 4.12 1.3H1.33333C0.6 1.3 0 1.885 0 2.6V11.7C0 12.415 0.6 13 1.33333 13H10.6667C11.4 13 12 12.415 12 11.7V2.6C12 1.885 11.4 1.3 10.6667 1.3ZM6 1.3C6.36667 1.3 6.66667 1.5925 6.66667 1.95C6.66667 2.3075 6.36667 2.6 6 2.6C5.63333 2.6 5.33333 2.3075 5.33333 1.95C5.33333 1.5925 5.63333 1.3 6 1.3ZM7.33333 10.4H2.66667V9.1H7.33333V10.4ZM9.33333 7.8H2.66667V6.5H9.33333V7.8ZM9.33333 5.2H2.66667V3.9H9.33333V5.2Z"/>
  </svg>
</template>
<script>
  export default {
    name: 'IconQuote'
  }
</script>